import { createContext, useContext } from "react"
import { FirestoreError } from "firebase/firestore"
import { Dayjs } from "dayjs"

export type HealthDocument<D = Dayjs> = {
    id: string
    status: "on" | "off"
    timestamp: D
    nextTimestamp?: D
    battery: number | null
    charging: boolean
    storage: number | number[]
    synced: number[],
    temp: number
    version?: string
    semver_version?: string
    nextStartup?: D
    nextShutdown?: D
    network?: string
}

export type HealthContextProps = {
    data: HealthDocument[]
    loading: boolean
    error?: FirestoreError
}

export const HealthContext = createContext<HealthContextProps>({
    data: [],
    loading: true,
    error: undefined,
})

export const useHealth = () => useContext(HealthContext)

export * from "./HealthProvider"
